import type {PartialOptions} from "../../../stem-core/ui/UIBase";
import {UI} from "../../../stem-core/ui/UIBase";

import {styleRule, StyleSheet} from "../../../stem-core/ui/Style";
import {PopupMenu} from "../../ui/PopupMenu.jsx";
import {Messages} from "../../Messages.js";
import {registerStyle} from "../../../stem-core/ui/style/Theme";
import {Subscription} from "../../../client/state/SubscriptionStore.js";
import {unwrapArray} from "../../../stem-core/base/Utils.js";
import {Toast} from "../../ui/Toast.jsx";
import type {UserAddress} from "../../../client/state/UserAddressStore";


class AddressInlineMenuStyle extends StyleSheet {
    @styleRule
    container = {
        display: "flex",
        justifyContent: "space-between",
        overflow: "initial !important",
    };

    @styleRule
    addressLine = {
        flex: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
    }
}

interface AddressInlineMenuOptions {
    address?: UserAddress;
    handleDelete?: any;
    handleEdit?: any;
}

@registerStyle(AddressInlineMenuStyle)
export class AddressInlineMenu extends UI.Element<AddressInlineMenuOptions> {
    getDefaultOptions(): PartialOptions<AddressInlineMenu> {
        return {
            address: null,
            handleEdit: null,
            handleDelete: null,
        }
    }

    // Returns the address only if it's not being used anywhere else
    selectAddressForChange() {
        const {address} = this.options;
        if (Subscription.getActiveWithAddress(address).length) {
            // TODO this is not a great error, but not really terrible
            Toast.showError(Messages.addressInUseError);
            return null;
        }

        return address;
    }

    getMenuItems() {
        const {handleEdit, handleDelete} = this.options;

        return unwrapArray([
            handleEdit && {
                content: Messages.edit,
                onClick: () => {
                    const address = this.selectAddressForChange();
                    if (address) {
                        handleEdit(address);
                    }
                },
            },
            handleDelete && {
                content: Messages.deleteMessage,
                onClick: () => {
                    const address = this.selectAddressForChange();
                    if (address) {
                        handleDelete(address);
                    }
                },
            }]);
    }

    render() {
        const {address} = this.options;

        return [
            <span className={this.styleSheet.addressLine}>{address}</span>,
            <PopupMenu items={this.getMenuItems()}/>
        ]
    }
}
